<template>
    <div class="busCouponList">
      <!-- 列表 -->
      <div class="vanCouponList">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="van-pull-refresh">
          <van-list
              v-model="loading"
              class="dataList"
              :finished="finished"
              @load="onLoad"
              v-if="couponList.length > 0"
              offset="300"
          >
            <div
                class="itemBox"
                v-for="(value, key) in couponList"
                :key="key"
            >
              <CouponItem
                  :coupon="value"
                  :status="status"
              />
            </div>
          </van-list>
          <!-- 没有数据 -->
          <div class="noData" v-else-if="!loading && !refreshing">
            <img
                src="../../assets/icon_no_coupon.png"
                alt=""
            />
            <p>无优惠券</p>
          </div>
        </van-pull-refresh>
      </div>
      <!-- 可拖动按钮组件 -->
      <SlidingButtons @toHistory="toHistory()"/>
      <!-- loading组件 -->
      <transition name="fade">
        <loading v-show="loading"></loading>
      </transition>
    </div>
</template>

<script>
import {personalCoupon} from "@/api/HttpService";
import CouponItem from "@/components/CouponItem/CouponItem.vue";
import SlidingButtons from "@/components/slidingButtons/slidingButtons.vue";
import Loading from "@/components/loading/loading.vue";

export default {
  components: {
    Loading,
    SlidingButtons,
    CouponItem,
  },
  name: "busCouponList",
  mounted: function () {
    document.title = "优惠券";
    this.loading = true;
    this.personalCoupon()
  },
  data: function () {
    return {
      loading: false,
      // 优惠券列表数据
      couponList: [],
      refreshing: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      status:1,

    };
  },
  methods: {
    // 获取数据
    personalCoupon: async function () {
      let params = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        kind:10,
        status:1,
        classes: 10,
      };
      await personalCoupon(params)
          .then(({res}) => {
            // 如果没有下一页了
            if(res.originalData.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS"){
              if (res.data.pageNum >= res.data.pages) {
                console.log("是否还有下一页")
                this.finished = true;
              } else {
                this.finished = false;
              }
              this.couponList.push(...res.data.data)
              this.pageNum++;
            }else{
              this.finished = true;
              this.$toast(res.originalData.bizMsg || "网络异常")
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast("网络异常");
            this.finished = true;
          });
      this.loading = false;
    },
    onLoad: async function () {
      console.log("加载下一页");
      this.loading = true;
      await this.personalCoupon();
    },
    // list刷新
    onRefresh: async function () {
      console.log("开始刷新");
      this.couponList = [];
      this.pageNum = 1;
      this.finished = false;
      this.loading = false;
      this.refreshing = true;
      await this.personalCoupon();
      this.refreshing = false;
    },
    // 历史优惠券
    toHistory: function () {
      this.$router.push({
        name: "HistoryListPage",
        query: {
          kind: 10,
        },
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "BusCouponListPage";
</style>
